// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1q0sb","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__KXrXM"};